module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_8003.4f6d98a7.png";